import { useEffect } from "react";
import { Outlet, useLocation, useMatch } from "react-router-dom";
import { Layout, Wrap } from "components";
import { scrollToTop } from "helpers";
import { useSignOut } from "hooks";
import { useGetUserQuery } from "features/api";
import Auth from "features/auth/Auth";

const App: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { data: user } = useGetUserQuery(undefined);
  const { pathname } = useLocation();
  const match = useMatch({ path: "/call/:id", end: true });
  const isFullscreen = match;
  const signOut = useSignOut();

  useEffect(() => scrollToTop("auto"), [pathname]);

  return (
    <Auth>
      <Wrap
        if={!isFullscreen}
        with={(children) => (
          <Layout user={user} onSignOut={signOut}>
            {children}
          </Layout>
        )}
      >
        {children}
        <Outlet />
      </Wrap>
    </Auth>
  );
};

export default App;
